import type { UserAgeRange } from "../../types/experiment";
import { Input } from "../ui/input";
import { Label } from "../ui/label";

interface UserAgeRangeFilterProps {
  value: UserAgeRange;
  onChange: (value: UserAgeRange) => void;
}

export function UserAgeRangeFilter({ value, onChange }: UserAgeRangeFilterProps) {
  return (
    <div className="flex gap-3">
      <div>
        <Label className="mb-1 block text-xs">Min Age (years)</Label>
        <Input
          type="number"
          value={value.min_age_years ?? ""}
          onChange={(e) =>
            onChange({ ...value, min_age_years: e.target.value ? parseInt(e.target.value) : undefined })
          }
          placeholder="min"
          className="w-24"
        />
      </div>
      <div>
        <Label className="mb-1 block text-xs">Max Age (years)</Label>
        <Input
          type="number"
          value={value.max_age_years ?? ""}
          onChange={(e) =>
            onChange({ ...value, max_age_years: e.target.value ? parseInt(e.target.value) : undefined })
          }
          placeholder="max"
          className="w-24"
        />
      </div>
    </div>
  );
}
